// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import SocialIcon from '../../../../internal/SocialIcon';

type SocialType = {|
  emailUrl: string,
  linkedInUrl: string,
  twitterUrl: string,
  facebookUrl: string,
|};

export default (props: SocialType) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  return (
    <div className={styles.socialContainer}>
      <ul className={styles.social}>
        <li>
          <SocialIcon href={props.emailUrl} className={styles.link} type="Email" />
        </li>
        <li>
          <SocialIcon href={props.linkedInUrl} className={styles.link} type="LinkedIn" />
        </li>
        <li>
          <SocialIcon href={props.twitterUrl} className={styles.link} type="Twitter" />
        </li>
        <li>
          <SocialIcon href={props.facebookUrl} className={styles.link} type="Facebook" />
        </li>
      </ul>
    </div>
  );
};
